import React from 'react';
import { withRouter } from 'react-router-dom';
import Inputs from 'components/inputs/inputs';
import Storage from 'utils/storage';

import image_error from 'assets/images/error-notice.png';

class AppErrorCatcher extends React.Component {
  constructor(props) {
    super();
    this.state = { hasError: false, error: null };

    props.history.listen(() => {
      this.reset();
    });
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: true, error: error });
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  resetAndGoBack = () => {
    this.props.history.goBack();
  };

  logout = () => {
    Storage.clear();
    this.props.history.push('/');
  };

  render() {
    let errorMessage = '';
    let hasError = false;

    if (this.state.hasError) {
      errorMessage = this.state.error.message;
      hasError = this.state.hasError;
    }
    else if (this.props.hasError) {
      errorMessage = this.props.errorMessage;
      hasError = this.props.hasError;
    }

    if (hasError) {
      return (
        <div className='vw-100 vh-100 d-flex justify-content-center align-items-center'>
          <div className='col-xs-10 col-sm-10 col-lg-8'>
            <div>
              <div className='text-center'>
                <img src={image_error} alt='Error' />
              </div>
              <div className='text-center'>
                <h1 className='text-danger font-weight-lighter mt-2'>Something went wrong</h1>
              </div>
              <div className='d-flex flex-column justify-content-between align-items-center'>
                <Inputs.Button variant='default' className='my-2' onClick={this.reset}>Reload Page</Inputs.Button>
                <Inputs.Button variant='default' className='my-2' onClick={this.resetAndGoBack}>Back To Previous Page</Inputs.Button>
                <Inputs.Button variant='default' className='my-2' onClick={this.logout}>Logout</Inputs.Button>
              </div>
              <h5 className='text-normal mt-3'>Sorry we're having some technical issues. If the issue persists, please contact system administrator.</h5>
              <div className='mt-3' style={{ maxHeight: '200', overflow: 'auto' }}>
                <code>
                  <ul>
                    {errorMessage.split('\n').map((item, index) => <li key={index}>{item}</li>)}
                  </ul>
                </code>
              </div>
            </div>
          </div>
        </div>
      );
    }
    else {
      return this.props.children;
    }
  }
}

export default withRouter(AppErrorCatcher);